import { useState, useEffect, useCallback } from 'react';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuthContext } from '../context/AuthContext';

/**
 * Fetches the current user's pick history (resolved + cancelled picks).
 * Sorted by most recent first.
 */
export function usePickHistory() {
  const { user } = useAuthContext();
  const [picks, setPicks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPicks = useCallback(async () => {
    if (!user) {
      setPicks([]);
      setLoading(false);
      return;
    }

    try {
      // Get all non-active picks (resolved: won/lost/push, or cancelled)
      const q = query(
        collection(db, 'picks'),
        where('uid', '==', user.uid),
        where('isActive', '==', false),
        orderBy('createdAt', 'desc')
      );

      const snapshot = await getDocs(q);
      const results = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPicks(results);
    } catch (err) {
      console.error('Error fetching pick history:', err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchPicks();
  }, [fetchPicks]);

  return { picks, loading, refetch: fetchPicks };
}
